<rt-box class="skills-header" layout-vertical margin-bottom>
  <div class="accent-bar"></div>
  <rt-heading>
    {{ 'app.interview.skills_section.heading' | translate }}
    <rt-badge [color]="'counter-default'" [text]="skillsCount" margin-left-small-x />
  </rt-heading>
  <span>
    {{ 'app.interview.skills_section.subheading' | translate }}
  </span>
</rt-box>

@let skillsValue = questionForm().controls.skillRatings;

@for (skillRating of skillsValue.controls; track skillRating.controls.skillId.value) {
  @let isInvalid = skillRating.invalid && formSubmissionAttempt();

  <rt-box
    variant="no-padding"
    rtQuestionRef
    [questionForm]="skillRating"
    [class.invalid]="isInvalid"
    layout-vertical
    margin-bottom
  >
    <div class="skill-question-header" layout-vertical>
      <div layout layout-align-items-center layout-space-between>
        <rt-heading>
          {{ skillRating.controls.skillName.value }}
          @if (skillRating.controls.proficiencyId.hasValidator(RequiredValidator)) {
            <span class="required" margin-left-small-xx> * </span>
          }
        </rt-heading>
        @if (isInvalid) {
          <div class="error-message">
            {{ 'app.common.form.required_error' | translate }}
          </div>
        }
      </div>
      @if (skillRating.controls.skillDescription.value) {
        <rt-heading [variant]="'dark normal'" margin-top-small-x>
          {{ skillRating.controls.skillDescription.value }}
        </rt-heading>
      }
    </div>

    <rt-divider />

    <div margin>
      @for (option of skillRating.controls.options.value; track option.value) {
        <div
          (click)="selectProficiency(skillRating, option.value)"
          class="item"
          margin-bottom-small-x
        >
          <rt-radio
            [hasAlignItemsStart]="true"
            [hasLensIcon]="true"
            [checked]="option.value === skillRating.controls.proficiencyId.value"
            (click)="$event.stopPropagation(); selectProficiency(skillRating, option.value)"
          >
            <div layout-vertical margin-top-small-xxx>
              <span
                [class.checked]="option.value === skillRating.controls.proficiencyId.value"
                class="title"
                >{{ option.option }}</span
              >
              <span class="description">{{ option.description }}</span>
            </div>
          </rt-radio>
        </div>
      }
    </div>
  </rt-box>
}
